var _defs, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 674.9 858.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        fill: #ee312c;\n        stroke: #a31724;\n      }\n\n      .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n        stroke-width: 30px;\n      }\n\n      .cls-5 {\n        fill: #7ba7d8;\n        stroke: #21409a;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 199.12,
    width: 357.87,
    height: 659.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 357.41,
    y: 191.36,
    width: 277.06,
    height: 636.08
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.02,254.5h-37.15c-69.29,0-125.44,53.18-125.44,118.77v252.86c0,65.6,56.16,118.79,125.44,118.79h37.15c69.29,0,125.46-53.18,125.46-118.79v-252.86c0-65.59-56.17-118.77-125.46-118.77Zm44.15,357.4c0,31.77-27.21,57.54-60.77,57.54h-6.72c-33.56,0-60.77-25.77-60.77-57.54v-222.93c0-31.77,27.21-57.53,60.77-57.53h6.72c33.56,0,60.77,25.75,60.77,57.53v222.93Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M336.1,15h-37.27c-69.51,0-125.85,53.18-125.85,118.77v252.86c0,65.6,56.34,118.79,125.85,118.79h37.27c69.51,0,125.86-53.18,125.86-118.79V133.77c0-65.59-56.35-118.77-125.86-118.77Zm44.29,357.4c0,31.77-27.3,57.54-60.97,57.54h-6.74c-33.67,0-60.97-25.77-60.97-57.54V149.46c0-31.77,27.3-57.53,60.97-57.53h6.74c33.67,0,60.97,25.75,60.97,57.53v222.93Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.9,254.53h-37.26c-69.49,0-125.81,53.18-125.81,118.77v252.86c0,65.6,56.32,118.79,125.81,118.79h37.26c69.49,0,125.83-53.18,125.83-118.79v-252.86c0-65.59-56.33-118.77-125.83-118.77Zm44.27,357.4c0,31.77-27.29,57.54-60.95,57.54h-6.74c-33.66,0-60.95-25.77-60.95-57.54v-222.93c0-31.77,27.29-57.53,60.95-57.53h6.74c33.66,0,60.95,25.75,60.95,57.53v222.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain1);
export default __webpack_public_path__ + "static/media/chain-1.0a9e265b6240b554d3fb63c179556edc.svg";
export { ForwardRef as ReactComponent };